<!-- <app-newcredit-claims-with-order [commentDataFromParent]="commentFromPopup"></app-newcredit-claims-with-order> -->
<div class="new-claim-modal container bg-white">
  <!-- <input type="text" [(ngModel)]="commentFromPopup"> -->
  <div class="row">
    <div class="new-claim-modal__content new-claim-modal__content col-12">
      <div class="cx-dialog-header modal-header">
        <div class="cx-dialog-title modal-title">
          <h3>{{ 'shared.addComment' | cxTranslate }}</h3>
        </div>
        <button
          type="button"
          class="close"
          aria-label="Close"
          cxModal="dismiss"
          cxModalReason="Cross click"
          (click)="closeModal()"
          >
          <span aria-hidden="true">
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </span>
        </button>
      </div>
      <div class="cx-dialog-body modal-body">
        <form [formGroup]="newClaimForm">
          @if (selectedOption) {
            <div class="upload row">
              <div class="col-6 upload__button__container">
                <div class="box">
                  @for (progressInfo of progressInfos; track progressInfo) {
                    <div class="mb-2">
                      <span>{{ progressInfo.fileName }}</span>
                      <div class="progress">
                        <div
                          class="progress-bar progress-bar-info progress-bar-striped"
                          role="progressbar"
                          attr.aria-valuenow="{{ progressInfo.percentage }}"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          [ngStyle]="{ width: progressInfo.percentage + '%' }"
                          >
                          {{ progressInfo.percentage }}%
                        </div>
                      </div>
                    </div>
                  }
                  <label class="btn btn-primary box__file-uploade" for="file-upload">
                    <i class="fas fa-upload"></i>
                    {{ 'shared.uploadImage' | cxTranslate }}
                  </label>
                  <input
                    id="file-upload"
                    type="file"
                    [disabled]="ImageUrls.length >= maxUploadCount"
                    class="inputfile inputfile-1"
                    accept="image/*"
                    multiple
                    (change)="selectFiles($event)"
                    />
                  </div>
                  <div class="alert alert-light" role="alert">{{ message }}</div>
                </div>
                <div class="col-6" [hidden]="ImageUrls.length === 0">
                  <div class="upload__preview">
                    @for (ImageUrl of ImageUrls; track ImageUrl) {
                      <img class="upload__preview__image" [src]="ImageUrl" />
                    }
                  </div>
                </div>
              </div>
            }

            <label class="comments">
              <span class="label-content">{{ 'creditClaims.order.commentText' | cxTranslate }}</span>
              <textarea
                class="form-control"
                type="text"
                name="message"
                maxlength="220"
                placeholder="{{ 'shared.enter' | cxTranslate }} {{ 'shared.comment' | cxTranslate }}"
                formControlName="comment"
              ></textarea>
              @if (newClaimForm?.controls?.comment?.value) {
                <p class="character-limit">
                  {{
                  'creditClaims.commentsHint' | cxTranslate: { count: 220 - newClaimForm.controls.comment.value.length }
                  }}
                </p>
              }
            </label>
          </form>
        </div>
        <div class="action-button">
          <button class="btn back-button btn-action" (click)="closeModal()">
            {{ 'common.cancel' | cxTranslate }}
          </button>

          <button
            class="btn btn-primary"
            type="submit"
            [disabled]="!newClaimForm.valid"
            (click)="closeModal(newClaimForm.value.comment)"
            >
            {{ 'common.submit' | cxTranslate }}
          </button>
        </div>
      </div>
    </div>
  </div>
